'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _products = require('ifeis-isomorphic/lib/redux/selectors/products');

var _immutable = require('immutable');

exports.default = function (feis_id) {
  return function (state) {

    var productsList = (0, _products.productsState)(state, feis_id);

    if (productsList.get('loading') || productsList.some(function (p_id) {
      return state.getIn(['products', 'images', p_id, 'loading']);
    })) {
      return { loading: true };
    }

    var products = productsList.map(function (p) {
      return (0, _products.getOneProduct)(state, p);
    }).map(function (p) {
      var imagesForProduct = (0, _products.getImagesList)(state, p.get('id')).map(function (image_id) {
        return (0, _products.getOneImage)(state, image_id);
      }) || (0, _immutable.List)();
      p = p.setIn(['images'], imagesForProduct);
      return p;
    });

    return {
      loading: false,
      collection: products
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./product-list/mapStateToController.js
// module id = 497
// module chunks = 0